import React, { useEffect, useState, useRef } from 'react';
import { Quotes } from '@phosphor-icons/react';
const testimonials = [{
  quote: 'Mateo was the TA for our UX Design Bootcamp. He always made himself available and went out of his way to help us achieve our goals.',
  name: 'Eric Lamontagne',
  title: 'Web Strategy Technical Lead',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Eric.jpg'
}, {
  quote: "Mateo's vast design knowledge was so helpful during my studies. Far beyond just a designer, Mateo brings a holistic approach to product development.",
  name: 'Alex Holder',
  title: "Design @ Dick's Sporting Goods",
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Alex.jpg'
}, {
  quote: 'Mateo is a great person to work with. His expertise and collaborative approach make him an invaluable team member on any project.',
  name: 'Tracey Jackson',
  title: 'A11y Specialist, Enterprise Banking',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Tracey.jpg'
}];
export function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    if (currentSection) {
      observer.observe(currentSection);
    }
    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);
  return <section className="bg-white" data-id="element-1861">
      <div ref={sectionRef} className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8" data-id="element-1862">
        <div className="container mx-auto max-w-6xl" data-id="element-1863">
          <h2 className="text-2xl sm:text-4xl md:text-5xl text-center mb-10 sm:mb-16 md:mb-20 uppercase leading-tight text-gray-800" style={{
          fontFamily: "'Gefika', sans-serif",
          fontWeight: 400,
          letterSpacing: '0.02em',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }} data-id="element-1864">
            Client & Co-Worker Comments
          </h2>

          {/* Static 3-column grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s'
        }} data-id="element-1865">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-sm border border-gray-100 p-8 sm:p-12 text-center shadow-sm" data-id="element-1866">
                {/* Avatar */}
                <div className="w-20 h-20 mx-auto mb-8 rounded-full p-1 bg-white border border-gray-100" data-id="element-1867">
                  <div className="w-full h-full rounded-full overflow-hidden" data-id="element-1868">
                    <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover grayscale" data-id="element-1869" />
                  </div>
                </div>

                {/* Quote */}
                <p className="text-slate-600 leading-relaxed mx-auto max-w-md text-base" data-id="element-1870">
                  {testimonial.quote}
                </p>

                {/* Divider */}
                <div className="w-24 h-px bg-gray-200 mt-6 mb-6 mx-auto" data-id="element-1871"></div>

                {/* Name & Title */}
                <div className="text-xs tracking-widest text-slate-500 uppercase" data-id="element-1872">
                  {testimonial.name}
                  <div className="mt-1" data-id="element-1873">{testimonial.title}</div>
                </div>

                {/* Quote Icon */}
                <div className="mt-8 inline-flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 text-slate-400 mx-auto" data-id="element-1874">
                  <Quotes size={18} weight="regular" data-id="element-1875" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}